<!-- <div class="row"> -->
	<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Descrizione'" [valueInput]="element.descrizione"></div>
	<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Valore'" [valueInput]="element.valore | euro"></div>
	<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
		[labelInput]="'Data scadenza'" [valueInput]="element.scadenza"></div>
<!-- </div> -->